<script>

    import { createEventDispatcher } from 'svelte'
	import { toast } from "bulma-toast"
	import { UsersStore, UserStore } from '../stores'
    
    import LocalSotreService from '../localstore'

    import InvoicesService from '../$services/invoices.service'

	import Form from '../$components/form.svelte'
	import InputEmail from '../$components/input.email.svelte'
	import InputText from '../$components/input.text.svelte'
    import ZipcodeColonyComponent from '../$components/zipcode.svelte'

    const dispatch = createEventDispatcher()

    let loading = false
    let data = {
        location: {}
    }
     
	async function createClient() {

        data.userId = $UserStore._id

		loading = true
		const resp = await InvoicesService.createClient(data)
		loading = false

		if(!resp.success)
			toast({message: resp.error.message, type: "is-danger" })
    
        LocalSotreService.setItem('admin', resp.data)
        UsersStore.replace(resp.data)
        UserStore.set(resp.data)

        toast({message: 'Datos de facturación creados', type: 'is-success'})
        dispatch('created', resp.data)
	}

</script>

<Form on:submit={createClient} on:canceled { loading } >
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.name} label="Nombre" icon="address-card" placeholder="Nombre" />
        </div>
    </div>
	<div class="columns">
		<div class="column">
			<InputText bind:value={data.rfc} label="RFC" icon="fingerprint" placeholder="RFC" />
		</div>
		<div class="column">
			<InputEmail bind:value={data.email} label="Correo" />
		</div>
	</div>
    <ZipcodeColonyComponent 
        bind:zipcode={data.location.zipcode}
        bind:state={data.location.state}
        bind:city={data.location.city}
        bind:municipality={data.location.municipality}
        bind:colony={data.location.colony}
    />
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.location.street} label="Calle" icon="map-marker-alt" placeholder="Calle" />
        </div>
    </div>
	<div class="columns">
		<div class="column">
			<InputText bind:value={data.location.number} label="Número" icon="hashtag" placeholder="Número" />
		</div>
		<div class="column">
			<InputText bind:value={data.location.apartment} label="Apartamento" icon="building" placeholder="Apartamento" required={false} />
		</div>
	</div>
</Form>